import { render, staticRenderFns } from "./FormGroupWrapper1.vue?vue&type=template&id=478c853d&"
import script from "./FormGroupWrapper1.vue?vue&type=script&lang=js&"
export * from "./FormGroupWrapper1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports